<template>
  <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4">
    <div
        class="py-[18px] px-4 rounded-[6px] bg-slate-100 dark:bg-slate-900"
        v-for="(item, i) in items"
        :key="i"
    >
      <div class="animate-pulse">
        <div class="flex items-start space-x-6 rtl:space-x-reverse">
          <div class="flex-none bg-[#C4C4C4] dark:bg-slate-500 h-10 w-10 rounded-circile">

          </div>
          <div class="flex-1 overflow-hidden break-words">
            <div
                class="rounded text-sm mb-3 font-medium h-4 bg-[#C4C4C4] dark:bg-slate-500"
            >

            </div>
            <div class="rounded w-full h-6 bg-[#C4C4C4] dark:bg-slate-500">

            </div>
          </div>
          <div>
            <div class="w-4 h-4 rounded bg-[#C4C4C4] dark:bg-slate-500 mb-2"></div>
            <div class="w-4 h-4 rounded bg-[#C4C4C4] dark:bg-slate-500"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paymentMethods",
  props: {
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      return Array.from({length: this.count});
    },
  },
}
</script>

<style scoped>

</style>
